import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@material-ui/core';
import { FileCopyOutlined } from '@material-ui/icons';
import ReactJsonView from '@microlink/react-json-view';
import React from 'react';

import { useModal } from './use-modal';
import { useSnackbar } from './use-snackbar';

export type Code =
    | {
          language: 'json';
          value: {};
      }
    | {
          language: 'sql';
          value: string;
      }
    | {
          language: 'text';
          value: string;
      };

export function useCodeModal() {
    const { showDialog, hideDialog } = useModal();
    const { setSnackbar } = useSnackbar();

    const getCodeContent = (title: string, code: Code) => {
        const handleCopy = () => {
            navigator.clipboard.writeText(code.language === 'json' ? JSON.stringify(code.value, null, 2) : code.value);
            setSnackbar('Copied to clipboard');
        };

        let content;
        if (code.language === 'json') {
            content = (
                <ReactJsonView
                    src={code.value}
                    name={null}
                    displayObjectSize={false}
                    displayDataTypes={false}
                    sortKeys={true}
                />
            );
        } else {
            content = <pre>{code.value}</pre>;
        }
        return (
            <Dialog open={true} onClose={hideDialog} fullWidth={true} maxWidth="lg">
                <DialogTitle>
                    <Typography
                        variant="h4"
                        component="div"
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                    >
                        {title}
                        <IconButton size="small" onClick={handleCopy}>
                            <FileCopyOutlined fontSize="small" />
                        </IconButton>
                    </Typography>
                </DialogTitle>
                <DialogContent dividers={true}>{content}</DialogContent>
                <DialogActions>
                    <Button onClick={hideDialog}>Close</Button>
                </DialogActions>
            </Dialog>
        );
    };

    const showCodeModal = (title: string, code: Code) => {
        showDialog(getCodeContent(title, code));
    };

    return { showCodeModal };
}
